module.exports = __webpack_public_path__ + "static/media/stop_red.4a85eecd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/stop_red.svg
// module id = 1068
// module chunks = 0